export const Base_Url = "https://backend.bionet.az";
